import React, { useMemo } from 'react';
// @ts-ignore: TS2459 — we know it's there at runtime
import { PerformanceChartsSection } from '@PikaDoApp/pikado-web-dsm';


interface PerformanceChartsContainerProps {
  pastMonthlyAverageList: any[];
  classMonthlyAverage: number | string;
  onMonthChange: (month: string) => void;
  monthOptions: Array<{label: string; value: string}>;
  selectedMonth: string;
}

export const PerformanceChartsContainer: React.FC<PerformanceChartsContainerProps> = ({
  pastMonthlyAverageList,
  classMonthlyAverage,
  onMonthChange,
  monthOptions,
  selectedMonth,
}) => {
  // Convert classMonthlyAverage to number if it's a string
  const averagePercentage = useMemo(() => {
    let value = 0;
    if (typeof classMonthlyAverage === 'string') {
      value = parseFloat(classMonthlyAverage) || 0;
    } else {
      value = classMonthlyAverage || 0;
    }
    // Ensure we only return valid, finite numbers
    return Number.isFinite(value) ? value : 0;
  }, [classMonthlyAverage]);

  // Transform pastMonthlyAverageList to the format expected by the chart
  const historicalPerformanceData = useMemo(() => {
    if (!pastMonthlyAverageList || pastMonthlyAverageList.length === 0) {
      return [];
    }

    return pastMonthlyAverageList.map((item: any) => {
      const yValue = Number.isFinite(item.average) ? item.average : 0;
      return {
        XData: item.month,
        YData: yValue,
      };
    });
  }, [pastMonthlyAverageList]);

  return (
    <PerformanceChartsSection
      averagePercentage={averagePercentage}
      historicalPerformanceData={historicalPerformanceData}
      monthOptions={monthOptions}
      selectedMonth={selectedMonth}
      onMonthChange={onMonthChange}
      donutTitle="Monthly Performance"
      areaChartTitle="Previous Months Performance"
      areaChartFillColor="rgba(116, 187, 231, 0.75)"
      areaChartStrokeColor="#74BBE7"
    />
  );
};
